import { render } from "./OneReservationComponent.vue?vue&type=template&id=812bdf90&scoped=true"
const script = {}

import "./OneReservationComponent.vue?vue&type=style&index=0&id=812bdf90&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Anupashyam\\Downloads\\gitlabs - rel path oops\\virtuallab-oop\\exp-10\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-812bdf90"]])

export default __exports__